<template>
  <Popover>
    <PopoverTrigger as-child>
      <button
        type="button"
        class="flex min-h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
      >
        <div class="flex flex-wrap gap-1">
          <template v-if="local && local.length">
            <span
              v-for="val in local"
              :key="val"
              class="inline-flex items-center rounded-md bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground hover:text-foreground"
            >
              {{ val }}
            </span>
          </template>
          <span v-else class="text-muted-foreground">Select...</span>
        </div>
      </button>
    </PopoverTrigger>
    <PopoverContent
      class="w-[var(--reka-popover-trigger-width)] p-2"
      align="start"
    >
      <div class="flex flex-col gap-1 max-h-60 overflow-y-auto">
        <label
          v-for="opt in item.enums"
          :key="opt"
          class="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm cursor-pointer hover:bg-accent"
        >
          <Checkbox
            :checked="local && local.includes(String(opt))"
            @update:checked="(checked) => onToggle(String(opt), checked)"
          />
          {{ opt }}
        </label>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script>
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import { Checkbox } from "@/shared/ui/checkbox";

export default {
  components: {
    Popover,
    PopoverTrigger,
    PopoverContent,
    Checkbox,
  },
  props: ["item"],
  data() {
    const raw = this.item.value;
    return {
      local: Array.isArray(raw) ? raw.map(String) : [],
    };
  },
  methods: {
    onToggle(opt, checked) {
      if (!Array.isArray(this.local)) this.local = [];
      if (checked) {
        if (!this.local.includes(opt)) {
          this.local = [...this.local, opt];
        }
      } else {
        this.local = this.local.filter((v) => v !== opt);
      }
      this.$emit(
        "update",
        this.item.key,
        this.local.length ? this.local : null
      );
    },
  },
};
</script>
